const SHOPIFY_FORMS_EMBED_SELECTOR = 'shopify-forms-embed';
const STYLE_ID = 'segway-shopify-forms-center-style';

// Tease tab: keep Shopify default (left-middle-rotated). Only center after open (form step).
const CENTER_STYLES = `
  #app-embed[data-form-root="true"][data-current-step="form"] {
    left: 50% !important;
    right: auto !important;
    top: 50% !important;
    bottom: auto !important;
    transform: translate(-50%, -50%) !important;
    rotate: 0deg !important;
    max-width: min(92vw, 480px);
  }
`;

const injectCenterStyles = embed => {
  const shadow = embed?.shadowRoot;

  if (!shadow || shadow.getElementById(STYLE_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = CENTER_STYLES;
  shadow.appendChild(style);
};

const syncAllEmbeds = () => {
  document.querySelectorAll(SHOPIFY_FORMS_EMBED_SELECTOR).forEach(injectCenterStyles);
};

if (!window.__shopifyFormsCenterInitialized) {
  syncAllEmbeds();

  const observer = new MutationObserver(syncAllEmbeds);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.addEventListener('load', () => {
    syncAllEmbeds();
    window.setTimeout(syncAllEmbeds, 2000);
  });

  window.__shopifyFormsCenterInitialized = true;
}
